module.exports = __webpack_public_path__ + "img/zu1030.8702902d.png";